import mixpanel from "mixpanel-browser";
mixpanel.init("03e258dcbee0de44e4dd13316c09e86c");
export default mixpanel;